<script setup>
import PrivacyYouTubeEmbed from '@/Components/PrivacyYouTubeEmbed.vue'
import { PhotoIcon } from '@heroicons/vue/24/outline'
import { ref } from 'vue'

const plans = [
    {
        name: 'Video',
        slug: 'video',
    },
]

const selected = ref(plans[0])
</script>

<template>
    <section
        id="o-nas"
        aria-label="Programátorské akce zaměřené na Laravel, Inertia.js, Vue.js a Tailwind CSS"
        class="scroll-mt-32"
    >
        <div
            class="mx-auto flex snap-x items-center space-x-4 overflow-x-auto rounded-full md:justify-center xl:justify-start xl:space-x-2 xl:p-0"
        >
            <div
                v-for="plan in plans"
                :key="plan.slug"
                class="w-full snap-center xl:w-fit"
            >
                <button
                    @click="selected = plan"
                    :class="[
                        selected.slug === plan.slug ? 'bg-brand-orange' : 'hover:bg-brand-orange bg-black/50',
                        'w-full shrink-0 cursor-pointer rounded-full px-5 py-4 text-center text-white transition-all duration-100 ease-linear xl:py-2',
                    ]"
                >
                    <span class="font-literata text-center text-xl 2xl:text-2xl">
                        {{ plan.name }}
                    </span>
                </button>
            </div>
        </div>

        <div class="mt-2">
            <div
                v-if="selected.slug === 'video'"
                class="bg-brand-orange relative isolate rounded-3xl p-2 xl:rounded-4xl xl:p-5"
            >
                <div class="mx-auto flex items-center justify-center overflow-hidden rounded-2xl">
                    <PrivacyYouTubeEmbed
                        video-id="m533FzMxtPY"
                        title="J&M Sádrokartony - Prezentace služeb"
                        class="relative h-[20rem] w-full lg:max-w-none xl:h-[35rem]"
                    />
                </div>
            </div>
            <div
                v-if="selected.slug === 'about'"
                class="bg-brand-orange relative isolate rounded-4xl p-5 sm:px-10 sm:py-24 md:p-5 lg:py-10 xl:px-24"
            >
                <div class="mx-auto flex items-center justify-center">
                    <PhotoIcon class="relative h-[30rem] w-auto stroke-1 lg:max-w-none" />
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.5s ease;
}
.fade-slide-enter-from,
.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(20px);
}
</style>
